import React from 'react';

const QualityBars = ({
  filledBars = 0,
  numBars = 5,
  filledColor = '#0e2774', // Dark blue
  unfilledColor = '#ced4da', // Light gray
  barHeight = 1,
  barWidth = 2,
  barGap = 0.35,
}) => {

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        height: `${barHeight}rem`,
      }}
    >
      {Array.from({ length: numBars }).map((_, index) => {
        const barIndex = index + 1;
        const isFilled = barIndex <= filledBars;

        return (
          <div
            key={index}
            style={{
              width: `${barWidth}rem`,
              height: `${barHeight}rem`,
              backgroundColor: isFilled ? filledColor : unfilledColor,
              borderRadius: '0.3rem', // Slight rounding for smoothness
              marginRight: index < numBars - 1 ? `${barGap}rem` : '0',
            }}
          />
        );
      })}
    </div>
  );
};

export default QualityBars;